import { render, staticRenderFns } from "./RiskInfo.vue?vue&type=template&id=74c874a2&scoped=true&"
import script from "./RiskInfo.vue?vue&type=script&lang=js&"
export * from "./RiskInfo.vue?vue&type=script&lang=js&"
import style0 from "./RiskInfo.vue?vue&type=style&index=0&id=74c874a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c874a2",
  null
  
)

export default component.exports